import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FORM_INPUT_REQS } from "../../../../../../app.config";
import { TradeIn } from "src/app/clearpath-module/models";

@Component({
  selector: "app-trade-in-form",
  templateUrl: "./trade-in-form.component.html",
  styleUrls: ["./trade-in-form.component.scss"]
})
export class TradeInFormComponent {
  @Input() formLabel = "Add Trade-in Vehicle";
  @Input() formGroup: UntypedFormGroup;
  @Input() submit: boolean;
  @Output() tradeInValueChange: EventEmitter<Partial<TradeIn>> = new EventEmitter();
  public REQS = FORM_INPUT_REQS;

  emitTradeInValueChange() {
    this.tradeInValueChange.emit({
      tradeValue: this.formGroup.value.tradeEstimate - this.formGroup.value.payOffEstimate,
      tradeEstimate: this.formGroup.value.tradeEstimate,
      payOffEstimate: this.formGroup.value.payOffEstimate,
      payOff: this.formGroup.value.payOffEstimate,
      year: this.formGroup.value.year,
      make: this.formGroup.value.make,
      model: this.formGroup.value.model,
    } as Partial<TradeIn>);
  }

  invalid(field?: string): boolean {
    if (field) {
      return this.submit && !this.formGroup.valid && !this.formGroup.get(field)?.value;
    }
    return false;
  }
}
